"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mode = void 0;
var constants_1 = require("../constants");
function mode(key, mode) {
    // Leaving the comparison as is, in case we change the mode name but not the setting.
    if (key === 'localhost')
        return constants_1.LOCALHOST_MODE;
    if ([constants_1.STANDALONE_MODE, constants_1.PRODUCER_MODE, constants_1.CONSUMER_MODE, constants_1.CONSUMER_PARTIAL_MODE].indexOf(mode) === -1)
        throw Error('Invalid mode provided');
    return mode;
}
exports.mode = mode;
